export default __webpack_public_path__ + "static/media/mass.ca363261.png";